import * as d3 from 'd3'
import { D3Position } from 'models'

interface Props {
  svg:
    | d3.Selection<SVGSVGElement | null, unknown, null, undefined>
    | d3.Selection<SVGGElement, unknown, null, undefined>
  areaStroke: string
  pathStr: string
}

/*
 * Filled Area Stroke
 * */
export const appendFilledAreaStroke = ({ svg, areaStroke, pathStr }: Props) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const existingFilledAreaStroke = svg.selectAll('.filled-area-stroke')
  if (!existingFilledAreaStroke.empty()) existingFilledAreaStroke.remove()

  svg
    .append('path')
    .attr('fill', 'none')
    .attr('stroke', `${areaStroke}`)
    .attr('d', `${pathStr}`)
    .attr('class', 'filled-area-stroke')
    .attr('stroke-width', 3)
    .attr('stroke-linejoin', 'bevel')
}

/*
 * Markers for the points the stroke leaves invisible. A subpath that never reaches a lineto is a
 * moveto on its own, and with the default butt linecap it paints nothing at all — a series of one
 * point draws an empty chart. Only such points are marked, so anything the stroke already draws
 * keeps its exact appearance.
 * */
export const appendIsolatedPointMarkers = ({
  svg,
  positions,
  color
}: {
  svg:
    | d3.Selection<SVGSVGElement | null, unknown, null, undefined>
    | d3.Selection<SVGGElement, unknown, null, undefined>
  positions: D3Position[]
  color: string
}) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const existing = svg.selectAll('.isolated-point')
  if (!existing.empty()) existing.remove()

  positions.forEach((position) => {
    svg
      .append('circle')
      .attr('class', 'isolated-point')
      .attr('cx', position.x)
      .attr('cy', position.y)
      .attr('r', 3)
      .attr('fill', color)
  })
}
